// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__m9DlD-sB","warning":"SignUpIncorrectBirthStep_warning__-Cv9Pr3A","back":"SignUpIncorrectBirthStep_back__hjIpceGq"};